<template>
  <span>
    Invoice
    <router-link tag="a" :to="`/invoices/view/${eventLog.invoiceId}`"
      >#{{ eventLog.invoiceNumber }}</router-link
    >&nbsp;that was issued to
    <router-link
      tag="a"
      :to="`/customers/view/${eventLog.customerId}`"
      >{{ eventLog.customerName }}</router-link
    >&nbsp;is now
    <div class="badge badge-pill badge-danger">Overdue</div>
  </span>
</template>
<script>
export default {
  name: 'recentActivityTableDescriptionInvoiceMarkedOverdue',
  props: {
    eventLog: {
      type: Object,
      default: () => {}
    }
  }
}
</script>
